import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetDocumentGroupListLoading, EGetDocumentGroupListActionType } from './types';

export const getDocumentGroupListLoading: () => TGetDocumentGroupListLoading =
  actionGenerator<EGetDocumentGroupListActionType.Loading>(EGetDocumentGroupListActionType.Loading);
